module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_1_null@3x.9a57bf99.png";